var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKontonummer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 13@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 32,
    cy: 32,
    r: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GDPR-Personopplysning-forside",
    transform: "translate(-590.000000, -2738.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(590.000000, 2738.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spotlight/-gjenstand-"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }), /*#__PURE__*/React.createElement("g", {
    id: "spotlight/-element",
    mask: "url(#mask-2)",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-60"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NAV-Brand/farge/-Bl\\xE5/-60",
    mask: "url(#mask-4)",
    fill: "#99C2E8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "bl\\xE5-60",
    points: "0 64 64 64 64 0 0 0"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M48,27 C48,24 47.0340908,21 41.8181818,21 L17.8636364,21 C15.7324545,21 14,22.683 14,24.75 L14,44.25 C14,46.3185 15.7324545,48 17.8636364,48 L41.8181818,48 C45.2259091,48 48,45.309 48,42 L48,27 Z",
    id: "Path",
    fill: "#B26D14",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,25.6 L18.4,25.6 C17.9584,25.6 17.6,25.2416 17.6,24.8 C17.6,24.3584 17.9584,24 18.4,24 L20,24 C20.44,24 20.8,24.3584 20.8,24.8 C20.8,25.2416 20.44,25.6 20,25.6 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,44.8 L18.4,44.8 C17.9584,44.8 17.6,44.4416 17.6,44 C17.6,43.5584 17.9584,43.2 18.4,43.2 L20,43.2 C20.44,43.2 20.8,43.5584 20.8,44 C20.8,44.4416 20.44,44.8 20,44.8 Z",
    id: "Path-Copy",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,24 C44.44,24 44.8,24.3584 44.8,24.8 C44.8,25.2416 44.44,25.6 44,25.6 L42.4,25.6 C41.9584,25.6 41.6,25.2416 41.6,24.8 C41.6,24.3584 41.9584,24 42.4,24 L44,24 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,43.2 C44.44,43.2 44.8,43.5584 44.8,44 C44.8,44.4416 44.44,44.8 44,44.8 L42.4,44.8 C41.9584,44.8 41.6,44.4416 41.6,44 C41.6,43.5584 41.9584,43.2 42.4,43.2 L44,43.2 Z",
    id: "Path-Copy-2",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "40 15 42 21 22 21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8,25.6 L23.2,25.6 C22.7584,25.6 22.4,25.2416 22.4,24.8 C22.4,24.3584 22.7584,24 23.2,24 L24.8,24 C25.24,24 25.6,24.3584 25.6,24.8 C25.6,25.2416 25.24,25.6 24.8,25.6 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8,44.8 L23.2,44.8 C22.7584,44.8 22.4,44.4416 22.4,44 C22.4,43.5584 22.7584,43.2 23.2,43.2 L24.8,43.2 C25.24,43.2 25.6,43.5584 25.6,44 C25.6,44.4416 25.24,44.8 24.8,44.8 Z",
    id: "Path-Copy-3",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,25.6 L28,25.6 C27.5584,25.6 27.2,25.2416 27.2,24.8 C27.2,24.3584 27.5584,24 28,24 L29.6,24 C30.04,24 30.4,24.3584 30.4,24.8 C30.4,25.2416 30.04,25.6 29.6,25.6 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,44.8 L28,44.8 C27.5584,44.8 27.2,44.4416 27.2,44 C27.2,43.5584 27.5584,43.2 28,43.2 L29.6,43.2 C30.04,43.2 30.4,43.5584 30.4,44 C30.4,44.4416 30.04,44.8 29.6,44.8 Z",
    id: "Path-Copy-4",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4,25.6 L32.8,25.6 C32.3584,25.6 32,25.2416 32,24.8 C32,24.3584 32.3584,24 32.8,24 L34.4,24 C34.84,24 35.2,24.3584 35.2,24.8 C35.2,25.2416 34.84,25.6 34.4,25.6 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4,44.8 L32.8,44.8 C32.3584,44.8 32,44.4416 32,44 C32,43.5584 32.3584,43.2 32.8,43.2 L34.4,43.2 C34.84,43.2 35.2,43.5584 35.2,44 C35.2,44.4416 34.84,44.8 34.4,44.8 Z",
    id: "Path-Copy-5",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2,25.6 L37.6,25.6 C37.1584,25.6 36.8,25.2416 36.8,24.8 C36.8,24.3584 37.1584,24 37.6,24 L39.2,24 C39.64,24 40,24.3584 40,24.8 C40,25.2416 39.64,25.6 39.2,25.6 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2,44.8 L37.6,44.8 C37.1584,44.8 36.8,44.4416 36.8,44 C36.8,43.5584 37.1584,43.2 37.6,43.2 L39.2,43.2 C39.64,43.2 40,43.5584 40,44 C40,44.4416 39.64,44.8 39.2,44.8 Z",
    id: "Path-Copy-6",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,35.25 C50,36.77 49.1492308,38 48.1076923,38 L41.8923077,38 C40.8476923,38 40,36.77 40,35.25 L40,32.75 C40,31.234 40.8492308,30 41.8923077,30 L48.1061538,30 C49.1492308,30 49.9984615,31.234 49.9984615,32.75 L49.9984615,35.25 L50,35.25 Z",
    id: "Path",
    fill: "#FFA733",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3E3832",
    cx: 43.6,
    cy: 34,
    r: 2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKontonummer);
export default __webpack_public_path__ + "static/media/Kontonummer.8a5f41405dfa0564768ce7bd373f2d26.svg";
export { ForwardRef as ReactComponent };